/**
 * AJAX CART DRAWER ENGINE & FREE SHIPPING CALCULATOR
 */

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.drawer = this.querySelector('.cart-drawer');
    this.closeBtn = this.querySelector('[data-cart-close]');
    this.itemsContainer = this.querySelector('[data-cart-items]');
    this.totalPriceEl = this.querySelector('[data-cart-total]');
    this.freeShippingBar = this.querySelector('[data-free-shipping-bar]');
    this.freeShippingText = this.querySelector('[data-free-shipping-text]');
    this.threshold = parseFloat(this.getAttribute('data-threshold') || 999);

    this.bindEvents();
  }

  getBackdrop() {
    return document.querySelector('[data-modal-backdrop]');
  }

  bindEvents() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Handle clicks on backdrop
    document.addEventListener('click', (e) => {
      const backdrop = this.getBackdrop();
      if (backdrop && e.target === backdrop && this.classList.contains('is-open')) {
        this.close();
      }

      const trigger = e.target.closest('[data-cart-trigger]');
      if (trigger) {
        e.preventDefault();
        this.open();
      }

      const quickAdd = e.target.closest('[data-quick-add-id]');
      if (quickAdd) {
        e.preventDefault();
        const variantId = quickAdd.getAttribute('data-quick-add-id');
        this.addItem(variantId, 1);
      }
    });

    this.addEventListener('change', (e) => {
      if (e.target.matches('[data-cart-quantity-input]')) {
        const key = e.target.getAttribute('data-key');
        const qty = parseInt(e.target.value);
        this.updateItem(key, qty);
      }
    });
  }

  open() {
    this.classList.add('is-open');
    const backdrop = this.getBackdrop();
    if (backdrop) backdrop.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    this.refreshCart();
  }

  close() {
    this.classList.remove('is-open');
    const backdrop = this.getBackdrop();
    if (backdrop) backdrop.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  async addItem(variantId, quantity = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] })
      });
      if (res.ok) {
        this.open();
        if (window.LakshivApp) {
          window.LakshivApp.constructor.showToast('Item added to cart! 🛍️');
        }
      } else {
        const data = await res.json();
        alert(data.description || 'Could not add item to cart');
      }
    } catch (e) {
      console.error('Cart add error:', e);
    }
  }

  async updateItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await res.json();
      this.renderCart(cart);
    } catch (e) {
      console.error('Cart update error:', e);
    }
  }

  async refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.renderCart(cart);
    } catch (e) {
      console.error('Fetch cart error:', e);
    }
  }

  renderCart(cart) {
    // Header cart count badges
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    // Drawer title count (plain inline display text)
    document.querySelectorAll('[data-cart-title-count]').forEach(el => {
      el.textContent = cart.item_count;
    });


    // Total price
    if (this.totalPriceEl) {
      this.totalPriceEl.textContent = `Rs. ${(cart.total_price / 100).toFixed(2)}`;
    }

    // Free shipping progress
    const totalAmount = cart.total_price / 100;
    if (this.freeShippingBar && this.freeShippingText) {
      if (totalAmount >= this.threshold) {
        this.freeShippingBar.style.width = '100%';
        this.freeShippingText.innerHTML = '🎉 You qualify for <strong>FREE Shipping!</strong>';
      } else {
        const remaining = (this.threshold - totalAmount).toFixed(2);
        const percentage = Math.min((totalAmount / this.threshold) * 100, 100);
        this.freeShippingBar.style.width = `${percentage}%`;
        this.freeShippingText.innerHTML = `Add <strong>Rs. ${remaining}</strong> more for <strong>FREE Shipping</strong>`;
      }
    }

    // Items list markup
    if (this.itemsContainer) {
      if (cart.item_count === 0) {
        this.itemsContainer.innerHTML = '<div style="text-align:center;padding:50px 20px;color:var(--color-text-muted);">Your cart is currently empty.</div>';
        return;
      }

      this.itemsContainer.innerHTML = cart.items.map(item => `
        <div style="display:flex;gap:16px;padding:16px 0;border-bottom:1px solid var(--color-border);align-items:center;">
          <img src="${item.featured_image ? item.featured_image.url : item.image}" alt="${item.title}" style="width:70px;height:70px;object-fit:cover;border-radius:12px;background:#f9f6f0;">
          <div style="flex:1;">
            <div style="font-weight:700;font-size:0.9rem;color:#111111;">${item.product_title}</div>
            <div style="font-size:0.8rem;color:var(--color-text-muted);">${item.variant_title || ''}</div>
            <div style="font-weight:800;margin-top:4px;color:var(--color-accent);">Rs. ${(item.final_price / 100).toFixed(2)}</div>
          </div>
          <div style="display:flex;align-items:center;gap:8px;border:1px solid var(--color-border);border-radius:999px;padding:2px 10px;background:#fff;">
            <button onclick="this.nextElementSibling.stepDown(); this.nextElementSibling.dispatchEvent(new Event('change', {bubbles:true}));" style="font-weight:700;">-</button>
            <input type="number" data-cart-quantity-input data-key="${item.key}" value="${item.quantity}" min="0" style="width:28px;text-align:center;font-weight:700;">
            <button onclick="this.previousElementSibling.stepUp(); this.previousElementSibling.dispatchEvent(new Event('change', {bubbles:true}));" style="font-weight:700;">+</button>
          </div>
        </div>
      `).join('');
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
